import { ActionButton, AltButton } from '../../common/Buttons/Buttons';
import { Input } from '../../common/Forms/Input/Input';

export const GeographicMunicipalityFormPanel = ({
  editingMunicipalityId,
  cityNameDisplay,
  stateSelectOptions,
  citySelectOptions,
  citySelectDisabled,
  register,
  errors,
  onSubmit,
  onCancel,
}) => (
  <>
    <h4 className="parameters-page__create-title">
      {editingMunicipalityId ? 'Editar municipio' : 'Crear nuevo municipio'}
    </h4>
    <div className="parameters-page__create-fields parameters-page__create-fields--city">
      <div
        className="row"
        style={{ width: '100%', alignItems: 'flex-start' }}
      >
        <Input
          bootstrap="col-12 col-md-3"
          label={editingMunicipalityId ? 'Estado' : 'Estado *'}
          type="select"
          name="stateId"
          options={stateSelectOptions}
          register={register}
          placeholder=""
          errors={errors?.stateId?.message}
          disabled={Boolean(editingMunicipalityId)}
        />
        {editingMunicipalityId ? (
          <>
            <input type="hidden" {...register('cityId')} />
            <div className="input-component-container col-12 col-md-3">
              <label htmlFor="municipality-city-display">Ciudad</label>
              <input
                id="municipality-city-display"
                type="text"
                className="i"
                value={cityNameDisplay ?? ''}
                disabled
                readOnly
                autoComplete="off"
              />
            </div>
          </>
        ) : (
          <Input
            bootstrap="col-12 col-md-3"
            label="Ciudad *"
            type="select"
            name="cityId"
            options={citySelectOptions}
            register={register}
            placeholder=""
            errors={errors?.cityId?.message}
            disabled={Boolean(citySelectDisabled)}
          />
        )}
        <Input
          bootstrap="col-12 col-md-3"
          label="Nombre del municipio *"
          type="text"
          name="municipalityName"
          register={register}
          placeholder="Nombre del municipio"
          errors={errors?.municipalityName?.message}
        />
        <div
          className="col-12 col-md-auto buttons-center-container"
          style={{ marginTop: '32px' }}
        >
          <ActionButton
            label={editingMunicipalityId ? 'Guardar cambios' : 'Guardar'}
            action={onSubmit}
          />
          <AltButton label="Cancelar" action={onCancel} />
        </div>
      </div>
    </div>
  </>
);
